import React from 'react';
import s from './Feature.css';
import classNames from 'classnames';
import CheckIcon from '@material-ui/icons/Check';
import useStyles from "isomorphic-style-loader/useStyles";

export default function Feature({ right, children, className, ...other }) {
    useStyles(s);

    return (
        <div className={classNames(s.feature, className, right ? s.right : s.left)} {...other}>
            {!right && <span><CheckIcon/> {children}</span>}
            {right && <span>{children}<CheckIcon/></span>}
        </div>
    );
}